import { gql } from '@apollo/client'
import { IPromotionData } from '@obeta/models/lib/models/Promotion/Promotion'

/**
 * Get data for the different kinds of promotions (Warenkorbaktionen or SAP Zugaben) via promotionId.
 *
 * Since this information is retrieved via Strapi, please use the Strapi endpoint through the useStrapiQuery hook.

 * @example
 * const { data } = useStrapiQuery({
 *   query: GET_OBETA_PROMOTION_QUERY,
 *   variables: { id: '10' },
 * })
 */
export const GET_OBETA_PROMOTION_QUERY = gql`
  query getObetaPromotion($id: ID!, $publicationState: PublicationState) {
    obetaPromotions(filters: { id: { eq: $id } }, publicationState: $publicationState) {
      data {
        attributes {
          name
          content
          startTime
          endTime
          algoliaQuery
          criteriaType
          createdAt
          updatedAt
          publishedAt
          showInApp
          showForObeta
          showForHaeusler
          showForEldis
          criteriaUnit
          benefits {
            name
            amount
            goalToReach
            image {
              data {
                attributes {
                  url
                  mime
                  width
                  height
                  formats
                }
              }
            }
          }
          promotionType
        }
      }
    }
  }
`

export type GET_OBETA_PROMOTION_QUERY_RESPONSE = {
  obetaPromotions: {
    data: Array<{
      attributes: IPromotionData
    }>
  }
}

/**
 * Helper function to get the first promotion from a query result
 * or undefined if no promotions were found
 */
export function getFirstPromotion(
  result?: GET_OBETA_PROMOTION_QUERY_RESPONSE
): IPromotionData | undefined {
  return result?.obetaPromotions?.data?.[0]?.attributes
}
